import Link from 'next/link';
import type { ReactNode } from 'react';

const LINK_PATTERN = /\[([^\]]+)\]\(([^)]+)\)/g;

export function parseGuideContent(content: string): ReactNode[] {
  const paragraphs = content.split(/\n\n+/).filter(Boolean);

  return paragraphs.map((paragraph, index) => (
    <p
      key={index}
      className="font-sans text-stone-600 font-light leading-relaxed mb-6 last:mb-0"
    >
      {parseInlineLinks(paragraph)}
    </p>
  ));
}

function parseInlineLinks(text: string): ReactNode[] {
  const nodes: ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  const pattern = new RegExp(LINK_PATTERN.source, 'g');

  while ((match = pattern.exec(text)) !== null) {
    if (match.index > lastIndex) {
      nodes.push(text.slice(lastIndex, match.index));
    }

    const label = match[1] ?? '';
    const href = match[2] ?? '';
    if (!href) continue;

    const isExternal = href.startsWith('http://') || href.startsWith('https://');

    if (isExternal) {
      nodes.push(
        <a
          key={`${match.index}-${href}`}
          href={href}
          className="text-stone-900 underline underline-offset-4 decoration-stone-300 hover:decoration-stone-900 transition-colors"
          target="_blank"
          rel="noopener noreferrer"
        >
          {label}
        </a>,
      );
    } else {
      nodes.push(
        <Link
          key={`${match.index}-${href}`}
          href={href}
          className="text-stone-900 underline underline-offset-4 decoration-stone-300 hover:decoration-stone-900 transition-colors"
        >
          {label}
        </Link>,
      );
    }

    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    nodes.push(text.slice(lastIndex));
  }

  return nodes.length > 0 ? nodes : [text];
}
